import {UserProxy} from '@extensions/proxies/user-proxy'
import React from 'react'
import {Util} from 'yougile-util'

export type UserStatusBackground = 'default' | 'dark'

type UserStatusProps = {
  readonly statusBackground?: UserStatusBackground
  borderSize?: number
} & Pick<UserProxy, 'userStatus' | 'userIsInDoNotDisturbMode'>

export const UserStatus = ({
  statusBackground,
  userIsInDoNotDisturbMode,
  userStatus
}: UserStatusProps) => {
  const statusClass = Util.bem('user-status', {
    offline: userStatus === 'offline',
    online: userStatus === 'online',
    'do-not-disturb': userIsInDoNotDisturbMode,
    [`${statusBackground}-background`]: true
  })

  return <div className={statusClass} />
}
